
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import InquiryForm from "./InquiryForm";

interface ServiceCardProps {
  id?: string;
  title: string;
  description: string;
  icon: React.ReactNode;
  features?: string[];
  onClick?: () => void;
}

const ServiceCard = ({ id, title, description, icon, features = [], onClick }: ServiceCardProps) => {
  // Extract slug from title for routing
  const slug = title.toLowerCase().replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '');
    
  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-soft hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 border border-gray-100 dark:border-gray-700">
      <div className="mb-4">
        <div className="inline-flex p-4 bg-indigo-100 dark:bg-indigo-900 rounded-2xl">
          {icon}
        </div>
      </div>
      <h3 className="text-xl font-semibold mb-2 text-gray-800 dark:text-white">{title}</h3>
      <p className="text-gray-600 dark:text-gray-300 mb-4">{description}</p>
      
      {features && features.length > 0 && (
        <div className="mb-4">
          <h4 className="font-medium mb-2 text-gray-700 dark:text-gray-300">Features:</h4>
          <ul className="space-y-1 text-sm text-gray-600 dark:text-gray-300">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start">
                <span className="mr-2">•</span>
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
      
      <div className="flex flex-col space-y-2 mt-4">
        <Link to={`/services/${slug}`}>
          <Button 
            variant="outline"
            className="w-full"
          >
            Learn More
          </Button>
        </Link>
        
        <Sheet>
          <SheetTrigger asChild>
            <Button 
              className="w-full curved-xl btn-gradient text-white"
            >
              Get Started
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[90vw] sm:w-[540px] overflow-y-auto curved-xl">
            <SheetHeader>
              <SheetTitle>Inquire about {title}</SheetTitle>
              <SheetDescription>
                Please fill out the form below and we'll get back to you shortly.
              </SheetDescription>
            </SheetHeader>
            <InquiryForm service={title} formType="service" />
          </SheetContent>
        </Sheet>
      </div>
    </div>
  );
};

export default ServiceCard;
